import { useTranslation } from 'react-i18next';
import { colors } from 'components/styles/variables';
import grayHeart from 'public/static/images/favorites/gray-heart.svg';
import useDialog from 'lib/hooks/useDialog';
import { DialogNames } from 'redux-implementations/dialog';
import styles from './styles';

const SignInCard = (): JSX.Element => {
  const { t } = useTranslation();
  const { open } = useDialog(DialogNames.Auth);
  return (
    <div className="empty-card-container">
      <div className="empty-card">
        <img className="empty-card-image gray-heart-icon" src={grayHeart} />
        <div className="empty-card-label sign-in-label">{t('favorites.signInTitle')}</div>
        <button onClick={(): void => open()}>{t('favorites.signIn')}</button>
      </div>
      <style jsx>{styles}</style>
      <style jsx>{`
        .sign-in-label {
          margin-bottom: 20px;
        }

        button {
          color: white;
          background-color: ${colors.ALR1};
          width: 138px;
          height: 40px;
          font-size: 16px;
          text-align: center;
          padding-top: 7px;
          padding-bottom: 9px;
          border: none;
          border-radius: 8px;
        }

        button:hover {
          background-color: ${colors.ALR2};
        }
      `}</style>
    </div>
  );
};

export default SignInCard;
